import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar el deseo de ser visto/a",
    opening: localizedGenderNode(
      [
      "Hoy no intento explicar.",
      "Solo noto el deseo de ser visto/a.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento explicar.",
      "Solo noto el deseo de ser visto/a.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo siento que los demás no me conocen de verdad?",
      "¿Qué en mí no tiene espacio allí?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo siento que los demás no me conocen de verdad?",
      "¿Qué en mí no tiene espacio allí?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar el deseo de ser visto/a ya es una conexión."
    ],
      [
      "Notar el deseo de ser visto/a ya es una conexión."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Lo que no muestro",
    opening: localizedGenderNode(
      [
      "Hoy observo lo que guardo adentro.",
      "No para cambiar.",
      "Solo ver."
    ],
      [
      "Hoy observo lo que guardo adentro.",
      "No para cambiar.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué oculto de la gente cercana?",
      "¿Por qué me lo guardo?",
      "¿Qué temo que pase si lo ven?"
    ],
      [
      "¿Qué oculto de la gente cercana?",
      "¿Por qué me lo guardo?",
      "¿Qué temo que pase si lo ven?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Guardar no significa que no haya verdad en mí."
    ],
      [
      "Guardar no significa que no haya verdad en mí."
    ]
    ),
    action: localizedGenderNode(
      "escribir una verdad para mí.",
      "escribir una verdad para mí."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Momentos en que me vieron",
    opening: localizedGenderNode(
      [
      "Hoy recuerdo momentos en que me vieron.",
      "Aunque sean pocos.",
      "Existen."
    ],
      [
      "Hoy recuerdo momentos en que me vieron.",
      "Aunque sean pocos.",
      "Existen."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo sentí que alguien me veía de verdad?",
      "¿Qué fue diferente allí?",
      "¿Qué hizo eso en mí?"
    ],
      [
      "¿Cuándo sentí que alguien me veía de verdad?",
      "¿Qué fue diferente allí?",
      "¿Qué hizo eso en mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso un momento pequeño de ser visto/a calienta."
    ],
      [
      "Incluso un momento pequeño de ser visto/a calienta."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Lo que busco",
    opening: localizedGenderNode(
      [
      "Hoy pregunto qué busco en la conexión.",
      "No una exigencia.",
      "Solo una necesidad."
    ],
      [
      "Hoy pregunto qué busco en la conexión.",
      "No una exigencia.",
      "Solo una necesidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el abdomen."
    ],
      [
      "Respiro despacio.",
      "Siento el abdomen."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito para sentirme conocido/a?",
      "¿Qué me falta allí?",
      "¿Qué me gustaría pedir con suavidad?"
    ],
      [
      "¿Qué necesito para sentirme conocido/a?",
      "¿Qué me falta allí?",
      "¿Qué me gustaría pedir con suavidad?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una necesidad clara suaviza el corazón."
    ],
      [
      "Una necesidad clara suaviza el corazón."
    ]
    ),
    action: localizedGenderNode(
      "escribir una necesidad en una palabra.",
      "escribir una necesidad en una palabra."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo que me sostiene",
    opening: localizedGenderNode(
      [
      "Hoy noto el miedo que me mantiene adentro.",
      "No para pelear con él.",
      "Solo ver."
    ],
      [
      "Hoy noto el miedo que me mantiene adentro.",
      "No para pelear con él.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué temo que pase si me conocen?",
      "¿Qué creo que perdería?",
      "¿Cómo me protege este miedo?"
    ],
      [
      "¿Qué temo que pase si me conocen?",
      "¿Qué creo que perdería?",
      "¿Cómo me protege este miedo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A veces el miedo es protección para un corazón sensible."
    ],
      [
      "A veces el miedo es protección para un corazón sensible."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Un lugar pequeño para expresar",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo dar un pequeño lugar a la expresión.",
      "No todo.",
      "Solo un poco."
    ],
      [
      "Hoy observo cómo dar un pequeño lugar a la expresión.",
      "No todo.",
      "Solo un poco."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento la garganta."
    ],
      [
      "Respiro despacio.",
      "Siento la garganta."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué parte pequeña de mí quiere ser escuchada?",
      "¿Dónde podría darle un lugar seguro?",
      "¿Qué paso pequeño puedo dar?"
    ],
      [
      "¿Qué parte pequeña de mí quiere ser escuchada?",
      "¿Dónde podría darle un lugar seguro?",
      "¿Qué paso pequeño puedo dar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso una expresión pequeña cambia algo."
    ],
      [
      "Incluso una expresión pequeña cambia algo."
    ]
    ),
    action: localizedGenderNode(
      "escribir una frase que no digo en voz alta.",
      "escribir una frase que no digo en voz alta."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Estar conmigo entre gente",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme conmigo incluso cuando hay gente.",
      "No desaparecer.",
      "Solo estar."
    ],
      [
      "Hoy practico quedarme conmigo incluso cuando hay gente.",
      "No desaparecer.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Siento mis pies."
    ],
      [
      "Me detengo un momento.",
      "Siento mis pies."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo se ve quedarme conmigo dentro de una conversación?",
      "¿Qué me recuerda a mí allí?",
      "¿Qué podría ayudarme a quedarme?"
    ],
      [
      "¿Cómo se ve quedarme conmigo dentro de una conversación?",
      "¿Qué me recuerda a mí allí?",
      "¿Qué podría ayudarme a quedarme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Quedarme conmigo es un ancla."
    ],
      [
      "Quedarme conmigo es un ancla."
    ]
    ),
    action: localizedGenderNode(
      "un toque pequeño en el corazón cuando estoy con gente.",
      "un toque pequeño en el corazón cuando estoy con gente."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una conexión pequeña y verdadera",
    opening: localizedGenderNode(
      [
      "Hoy busco una conexión pequeña que sea verdadera.",
      "No grande.",
      "Solo verdadera."
    ],
      [
      "Hoy busco una conexión pequeña que sea verdadera.",
      "No grande.",
      "Solo verdadera."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Con quién me siento más verdadero/a?",
      "¿Qué hay allí que permite la verdad?",
      "¿Qué paso pequeño podría profundizarlo?"
    ],
      [
      "¿Con quién me siento más verdadero/a?",
      "¿Qué hay allí que permite la verdad?",
      "¿Qué paso pequeño podría profundizarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una verdad pequeña puede cambiar la cercanía."
    ],
      [
      "Una verdad pequeña puede cambiar la cercanía."
    ]
    ),
    action: localizedGenderNode(
      "recordar a una persona que se siente cercana.",
      "recordar a una persona que se siente cercana."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Atreverme un poco",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo es atreverme un poco.",
      "No mucho.",
      "Solo un paso pequeño."
    ],
      [
      "Hoy observo cómo es atreverme un poco.",
      "No mucho.",
      "Solo un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño me da miedo dar?",
      "¿Cuál es la cosa más pequeña y segura?",
      "¿Cómo me sentiré después?"
    ],
      [
      "¿Qué paso pequeño me da miedo dar?",
      "¿Cuál es la cosa más pequeña y segura?",
      "¿Cómo me sentiré después?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un coraje pequeño es suficiente para hoy."
    ],
      [
      "Un coraje pequeño es suficiente para hoy."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Pedir reconocimiento",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo pedir reconocimiento con suavidad.",
      "Sin drama.",
      "Solo una palabra."
    ],
      [
      "Hoy observo cómo pedir reconocimiento con suavidad.",
      "Sin drama.",
      "Solo una palabra."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me gustaría que alguien supiera de mí?",
      "¿Cómo puedo decirlo con suavidad?",
      "¿Qué cosa pequeña estoy dispuesto/a a compartir?"
    ],
      [
      "¿Qué me gustaría que alguien supiera de mí?",
      "¿Cómo puedo decirlo con suavidad?",
      "¿Qué cosa pequeña estoy dispuesto/a a compartir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño compartir abre una grieta en la pared."
    ],
      [
      "Un pequeño compartir abre una grieta en la pared."
    ]
    ),
    action: localizedGenderNode(
      "escribir una frase que quisiera compartir.",
      "escribir una frase que quisiera compartir."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Alguien que me conoce un poco",
    opening: localizedGenderNode(
      [
      "Hoy noto quién quizá me conoce un poco.",
      "No tiene que ser mucho.",
      "Solo un poco."
    ],
      [
      "Hoy noto quién quizá me conoce un poco.",
      "No tiene que ser mucho.",
      "Solo un poco."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Quién conoce algo real de mí?",
      "¿Qué sabe de mí?",
      "¿Cómo se siente saber que hay alguien así?"
    ],
      [
      "¿Quién conoce algo real de mí?",
      "¿Qué sabe de mí?",
      "¿Cómo se siente saber que hay alguien así?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un poco de reconocimiento todavía cuenta."
    ],
      [
      "Un poco de reconocimiento todavía cuenta."
    ]
    ),
    action: localizedGenderNode(
      "guardar el nombre de esa persona en el corazón.",
      "guardar el nombre de esa persona en el corazón."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Una voz interna que me conoce",
    opening: localizedGenderNode(
      [
      "Hoy busco una voz interna que me conoce.",
      "Aunque sea silenciosa.",
      "Está allí."
    ],
      [
      "Hoy busco una voz interna que me conoce.",
      "Aunque sea silenciosa.",
      "Está allí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Le doy espacio."
    ],
      [
      "Respiro despacio.",
      "Le doy espacio."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué sabe esa voz de mí?",
      "¿Qué me dice ahora?",
      "¿Cómo se siente escucharla?"
    ],
      [
      "¿Qué sabe esa voz de mí?",
      "¿Qué me dice ahora?",
      "¿Cómo se siente escucharla?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz interna que me conoce es un hogar."
    ],
      [
      "Una voz interna que me conoce es un hogar."
    ]
    ),
    action: localizedGenderNode(
      "una frase de esa voz.",
      "una frase de esa voz."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño de cercanía",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de cercanía.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de cercanía.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para moverme."
    ],
      [
      "Un paso pequeño es suficiente para moverme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a sentirme visto/a.",
      "Cuando me cierro.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a sentirme visto/a.",
      "Cuando me cierro.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mi necesidad de ser conocido/a?",
      "¿Cuál es la primera señal de que me cierro?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre mi necesidad de ser conocido/a?",
      "¿Cuál es la primera señal de que me cierro?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo sentirme no visto/a y aun así quedarme conmigo."
    ],
      [
      "Puedo sentirme no visto/a y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const iHaveNoOneWhoReallyKnowsMeBlueprintEs = buildNormalizedPilotBlueprint({
  id: "i_have_no_one_who_really_knows_me_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "i_have_no_one_who_really_knows_me",
  category: "loneliness_belonging",
  journeyName: {
    he: "אין לי אף אחד שבאמת מכיר אותי",
    en: "I have no one who really knows me",
    es: "No tengo a nadie que de verdad me conozca",
  },
  days,
});

export default iHaveNoOneWhoReallyKnowsMeBlueprintEs;
